var $=jQuery;
$(document).ready(function () {  
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').slideUp();
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', function() {
        setEqualHeight();
    });
    $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
    ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //Slider collection list
    // $('.collection-list').flickity({ 
    //     imagesLoaded: true,
    //     groupCells: false,
    //     dragThreshold: 5,
    //     cellAlign: 'left',
    //     wrapAround: true,
    //     prevNextButtons: true,
    //     percentPosition: true, 
    //     pageDots: false,
    //     rightToLeft: false,
    //     autoPlay: false,
    // });
    //End Slider collection list

    /*** LOAD MORE **/
  $(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');
        
        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});

/** LOAD MORE****/
/* JS slider price filter */
class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);
/* JS slider price filter */


/* Bundles js update variation change */
$(document).on('change', '.select__select', function () {
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');
  var selectedOptions = [];
  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });
  var variants = JSON.parse($productItem.attr('data-variants'));
  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });
  if (matchedVariant) {
    var $priceContainer = $productItem.find('.price-custom');
    var priceHtml = '';
    if (matchedVariant.compare_at_price > matchedVariant.price) {
      priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
      priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
      priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
    } else {
      priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
    }
    $priceContainer.html(priceHtml);
    $productItem.find('.product-variant-id').val(matchedVariant.id);
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }
});

$('.qty-plus').on('click', function () {
    const $input = $(this).siblings('.qty-input');
    let currentVal = parseInt($input.val());
    if (!isNaN(currentVal)) {
      $input.val(currentVal + 1);
    } else {
      $input.val(1);
    }
  });
  $('.qty-minus').on('click', function () {
    const $input = $(this).siblings('.qty-input');
    let currentVal = parseInt($input.val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $input.val(currentVal - 1);
    } else {
      $input.val(1);
    }
  });
  $(document).on('change', '.select__select', function () {
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');
  var selectedOptions = [];
  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });
  $productItem.find('.product-variant-id').val($select.val());
  var variants = JSON.parse($productItem.attr('data-variants'));
  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });
  if (matchedVariant) {
    var $priceContainer = $productItem.find('.regular-price');
    var priceHtml = '';

    if (matchedVariant.compare_at_price > matchedVariant.price) {
      priceHtml = formatMoney(matchedVariant.compare_at_price);
    } else {
      priceHtml = formatMoney(matchedVariant.price);
    }

    $priceContainer.html(priceHtml);
    
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }  
  $('p.footer-block__heading.inline-richtext.has__dropdown').on('click', function() {
    $(this).toggleClass('active');
  });

});
/* Bundles js update variation change */
  $('.connected-products select').on('change', function() {
    if($('.connected-products select option:selected').data('url') != ""){
      window.location.href = $('.connected-products select option:selected').data('url');
    }
  });
  $(document).on('click', '.details-pdp .min_head h5, .crosscell_pdp .page-width .min_head h5', function () {
    $(this).toggleClass('toggle');
    $(this).parent('.min_head').next('ul').toggle();
  });
  var swiper = new Swiper('.slider-upsell', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 50000,
    disableOnInteraction: false,
  },
   navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
  },
});
});
